 /**
  * Adjust resourcelib_tag URLs
  */
jQuery(function($){
    var page_uri = new URI();
    var page_qs = page_uri.search(true);
    $('.resourcelib-taxonomy__term-link', '.resourcelib-taxonomy--resourcelib_tag').each(function(){
        var link_uri = new URI(this);
        var link_qs = link_uri.search(true);
        link_uri.setSearch(page_qs);
        link_uri.setSearch(link_qs);
        link_qs = link_uri.search(true);
        link_uri.search('');
        var link_keys = [];
        $.each(link_qs, function(k, v){
            link_keys.push(k);
        });
        $.each(link_keys.sort(),function(i, v){
            link_uri.setSearch(v, link_qs[v]);
        });
        this.href = link_uri.toString();
    });
});

/**
 * Events:
 * resourcelib:next, resourcelib:postsLoaded
 */
jQuery(function($){
    var stateObj = {};
    $('.resourcelib-pagination__nav--next .resourcelib-pagination__nav-link, .resourcelib-next .resourcelib-link', '.resourcelib-pagination').on('click', function(e) {
        e.preventDefault();
        var link = $(this);
        var link_container = link.closest('.resourcelib-pagination__nav--next, .resourcelib-next');
        var container = link.closest('.resourcelib-view, .resourcelib-posts');
        var paged = container.data('paged');
        container.data('paged', ++paged);
        var req = {
            action: 'myajax',
            data_id: container.data('dataId'),
            paged: paged
        };
        container.trigger('resourcelib:next');
        $.get(mdresourcelib.ajaxurl, req).done(function(response){
            // use ".resourcelib-items > .resourcelib-wrapper" for older theme versions
            $('.resourcelib-posts, .resourcelib-items > .resourcelib-wrapper', container).append(response);
            if (paged == container.data('maxNumPages')) {
                link_container.addClass('off');
            }
            container.trigger('resourcelib:postsLoaded');
        });
    });
});





/**
 * Watch "nooz-posts" container element for size changes.
 */
(function(){
    var smCardMinWidth = 240 + 30;
    var mdCardMinWidth = 250 + 30;
    var lgCardMinWidth = 310 + 30;

    var sm = 551;
    var views = document.getElementsByClassName('resourcelib-posts');
    function removeClassName(el, className) {
        var arr = el.className.split(' ');
        var idx = arr.indexOf(className);
        if (idx === -1) return;
        arr.splice(idx, 1);
        el.className = arr.join(' ');
    }
    function addClassName(el, className) {
        if (el.className.split(' ').indexOf(className) > -1) return;
        el.className += ' ' + className;
    }
    var smCardCountAvailable = 1;
    var mdCardCountAvailable = 1;
    var lgCardCountAvailable = 1;
    function setBreakpoint() {
        for (var i = 0; i < views.length; i++) {
            var el = views[i];
            var rect = el.getBoundingClientRect();

            var mdCardCount = Math.floor(rect.width/mdCardMinWidth);
            spaceAvailable = el.getAttribute('data-md-items');
            if (spaceAvailable != mdCardCount) {
                //spaceAvailable = mdCardCount;
                //for (var j=0; j<=5; j++) removeClassName(el, 'resourcelib-posts--md-i' + j);
                //addClassName(el, 'resourcelib-posts--md-i' + mdCardCount);
                el.setAttribute('data-space-md', mdCardCount);
            }

            var lgCardCount = Math.floor(rect.width/lgCardMinWidth);
            spaceAvailable = el.getAttribute('data-lg-items');
            if (spaceAvailable != lgCardCount) {
                //lgCardCountAvailable = lgCardCount;
                //for (var j=0; j<=5; j++) removeClassName(el, 'resourcelib-posts--lg-i' + j);
                //addClassName(el, 'resourcelib-posts--lg-i' + lgCardCount);
                el.setAttribute('data-space-lg', lgCardCount);
            }
        }
    }
    // respond to window resize event
    window.addEventListener('resize', setBreakpoint);
    // respond to user events
    document.body.addEventListener('click', function(e){
        // wait for other behavior to complete
        setTimeout(setBreakpoint, 200);
    });
    setBreakpoint();
})();
